jQuery(document).ready(function($) {
  // Mobile navi
  $('button.hamburger').click(function() {
    $(this).find('span#nav-icon').toggleClass('open');
    $(this).toggleClass('open');
    $('body').toggleClass('navi-open');
    if ($('body').hasClass('navi-open')) {
      $('nav.main-navi').slideDown(300);
      $(this).attr('aria-expanded', 'true');
    }
    else {
      $('nav.main-navi').hide();
      $(this).attr('aria-expanded', 'false');
    }
  });

  if ($(window).width() < 960) {
    $('li.menu-item-has-children > a').click(function(e) {
      if ( !$(this).hasClass('open') ) {
        e.preventDefault();
        $(this).addClass('open');
        $(this).parent().find('ul').show();
      }
      else {
        $(this).removeClass('open');
      }
    });
  }

  // Avautuva sisältö

  $('a.accordion-title').click(function(e) {
    e.preventDefault();
    var elm = $(this).next();
    var parent = $(this).parent();
    var parent_class_changed = false;
    $('div.accordion-content-wrap').not(elm).slideUp();
    $('a.accordion-title').not(this).removeClass('open');
    $('div.accordion-item').not(parent).removeClass('open');
    $(this).toggleClass('open');
    if (!parent.hasClass('open')) {
      parent.toggleClass('open');
      parent_class_changed = true;
    }
    elm.slideToggle(function() {
      if (!parent_class_changed)
        parent.toggleClass('open');
    });
  });

  // Galleria

  var galleryLinks = document.querySelectorAll('.gallery a');
  if (galleryLinks.length > 0) {

    var numLinks = galleryLinks.length;
    var currentLink = 0;

    // Create the modal
    var modal = document.createElement('div');
    modal.classList.add('modal');
    modal.innerHTML = `
      <img class="modal-image" />
      <div class="modal-title"></div>
      <!-- <a class="modal-download" href="" download>Lataa kuva</a> -->
      <div class="modal-counter"></div>
      <div class="modal-prev">&#10094;</div>
      <div class="modal-next">&#10095;</div>
    `;
    document.body.appendChild(modal);

    var modalImage = modal.querySelector('.modal-image');
    var modalTitle = modal.querySelector('.modal-title');
    //var modalDownload = modal.querySelector('.modal-download');
    var modalCounter = modal.querySelector('.modal-counter');
    var modalPrev = modal.querySelector('.modal-prev');
    var modalNext = modal.querySelector('.modal-next');

    // Show the modal when a link is clicked
    galleryLinks.forEach(function(link, index) {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        currentLink = index;
        showModal(currentLink);
      });
    });

    // Show the modal with the current image
    function showModal(index) {
      var href = galleryLinks[index].getAttribute('href');
      var title = galleryLinks[index].getAttribute('title');
      var counter = (index + 1) + '/' + numLinks;
      modalImage.setAttribute('src', href);
      modalTitle.textContent = title;
      //modalDownload.setAttribute('href', href);
      modalCounter.textContent = counter;
      modal.style.display = 'block';
    }

    // Hide the modal when the background is clicked
    modal.addEventListener('click', function(event) {
      if (event.target === modal) {
        modal.style.display = 'none';
      }
    });

    // Show the previous image
    modalPrev.addEventListener('click', function() {
      currentLink--;
      if (currentLink < 0) {
        currentLink = numLinks - 1;
      }
      showModal(currentLink);
    });

    // Show the next image
    modalNext.addEventListener('click', function() {
      currentLink++;
      if (currentLink >= numLinks) {
        currentLink = 0;
      }
      showModal(currentLink);
    });

    // Keyboard navigation
    document.addEventListener('keydown', function(event) {
      if (modal.style.display !== 'block') return;
      if (event.key === 'ArrowLeft') {
        currentLink--;
        if (currentLink < 0) {
          currentLink = numLinks - 1;
        }
        showModal(currentLink);
      } else if (event.key === 'ArrowRight') {
        currentLink++;
        if (currentLink >= numLinks) {
          currentLink = 0;
        }
        showModal(currentLink);
      } else if (event.key === 'Escape') {
        modal.style.display = 'none';
      }
    });

    // Pop-up functionality
    var popUpSection = document.querySelector('section.pop-up');
    if (popUpSection) {
      var popUpItems = document.querySelectorAll('.pop-up-item');
      popUpItems.forEach(function(item) {
        item.addEventListener('click', function(e) {
          e.preventDefault();
          var popupContent = item.querySelector('.pop-up-content').cloneNode(true);
          var popupBg = document.createElement('div');
          popupBg.classList.add('popup-bg');
          document.body.appendChild(popupBg);
          document.body.appendChild(popupContent);
          var closeBtn = document.createElement('a');
          closeBtn.setAttribute('href', '#');
          closeBtn.classList.add('close');
          closeBtn.textContent = 'Sulje';
          popupContent.appendChild(closeBtn);
          popupContent.style.top = (window.scrollY + window.innerHeight * 0.1) + 'px';
          popupBg.style.display = 'block';
          popupContent.style.display = 'block';

          // Close pop-up
          popupBg.addEventListener('click', closePopup);
          closeBtn.addEventListener('click', closePopup);
        });
      });

      function closePopup(e) {
        e.preventDefault();
        var popupBg = document.querySelector('.popup-bg');
        var popupContent = document.querySelector('body > .pop-up-content');
        if (popupBg) popupBg.remove();
        if (popupContent) popupContent.remove();
      }
    }
  }

  // Galleria END

}); // jQuery(document).ready

(function () {
  const win = window;
  const body = document.body;
  let ticking = false;
  const stickyOffset = 204;
  function onScroll() {
    const scrollTop = win.pageYOffset || document.documentElement.scrollTop;
    const isSticky = scrollTop > stickyOffset;
    if (isSticky !== body.classList.contains('sticky-header')) {
      body.classList.toggle('sticky-header', isSticky);
    }
    ticking = false;
  }
  win.addEventListener('scroll', function () {
    if (!ticking) {
      win.requestAnimationFrame(onScroll);
      ticking = true;
    }
  }, { passive: true });
})();

document.addEventListener('DOMContentLoaded', function () {
  // Mobile news archive toggle
  const archiveToggle = document.querySelector('.archives-wrap h4');
  const archiveWrap = document.querySelector('.archives-wrap');
  if (archiveToggle && archiveWrap) {
    archiveToggle.addEventListener('click', function () {
      archiveWrap.classList.toggle('open');
    });
  }
  // News items load more btn
  const batchSize = 3;
  const items = document.querySelectorAll('.news-item');
  const button = document.querySelector('.load-more-news');
  if (button && items.length > 0) {
    let visible = batchSize;
    button.addEventListener('click', function () {
      for (let i = visible; i < visible + batchSize; i++) {
        if (items[i]) {
          items[i].classList.remove('hidden');
        }
      }
      visible += batchSize;
      if (visible >= items.length) {
        button.style.display = 'none';
      }
    });
  }
  // Kuvakaruselli yliopiston sivulla
  const gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    const slides = gallery.querySelectorAll('.slide');
    const dots = gallery.querySelectorAll('.dot');
    const prev = gallery.querySelector('.gallery-prev');
    const next = gallery.querySelector('.gallery-next');
    let current = 0;
    let interval;
    function show(index) {
      slides.forEach((slide, i) => {
        slide.classList.toggle('active', i === index);
      });

      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });

      current = index;
    }
    function nextSlide() {
      let index = (current + 1) % slides.length;
      show(index);
    }
    function prevSlide() {
      let index = (current - 1 + slides.length) % slides.length;
      show(index);
    }
    function startAuto() {
      interval = setInterval(nextSlide, 5000);
    }
    function stopAuto() {
      clearInterval(interval);
    }
    // Events
    if (next) next.addEventListener('click', () => {
      nextSlide();
      stopAuto();
      startAuto();
    });
    if (prev) prev.addEventListener('click', () => {
      prevSlide();
      stopAuto();
      startAuto();
    });
    dots.forEach(dot => {
      dot.addEventListener('click', function () {
        const index = parseInt(this.dataset.index);
        show(index);
        stopAuto();
        startAuto();
      });
    });
    // Init
    startAuto();
  }
});